// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {connect} from 'react-redux'
import Checkbox from '@material-ui/core/Checkbox'

import UpdateForm from '../UpdateForm'
import {checkItems, showEditForm, changeCheckAllBoxState} from '../../../actions/table'
// Icons
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'

import './index.css'

class ItemInfo extends Component {
  componentDidUpdate (prevProps) {
    if (prevProps.table.checkAll !== this.props.table.checkAll) {
      let checked = this.isChecked()
      if (!checked && this.props.table.checkAll) {
        this.props.checkItems(this.props.item, this.props.formNumber)
      } else if (checked && prevProps.table.checkAll && !this.props.table.checkAll) {
        this.props.checkItems(this.props.item, this.props.formNumber)
      }
    }
  }

  isChecked = () => {
    const {formNumber, table} = this.props
    return table.checkedItems ? table.checkedItems[formNumber] != null : false
  }

  onCheckChange = () => {
    let checked = this.isChecked()
    let {checkAll} = this.props.table
    if (!checked && checkAll) {
      this.props.changeCheckAllBoxState(true, false)
    }
  }

  renderUpdateForm () {
    const {item,
      formName,
      formNumber,
      updateFields,
      validate,
      onSubmit,
      showEditForm,
      updateButtons,
      checkBoxes} = this.props

    return (
      <UpdateForm
        form={formName}
        item={item}
        key={formName}
        formNumber={formNumber}
        fields={(item) => updateFields(item)}
        validate={validate}
        onSubmit={onSubmit}
        showEditForm={showEditForm}
        initialValues={item}
        updateButtons={updateButtons}
        checkBoxes={checkBoxes}
      />
    )
  }

  render () {
    const {formNumber, table, infoFields, item, checkBoxes, editEnabled} = this.props
    const checked = this.isChecked()
    const {editing} = table
    if (editing === formNumber) {
      return this.renderUpdateForm()
    }

    const edditingBottomItem = (editing === (formNumber + 1))

    let className = edditingBottomItem ? 'no-bottom-border' : ''

    return (
      <div className={`tr item-info row ${className}`}>
        { checkBoxes &&
        <div className='th col-1 user-icon'><Checkbox onChange={() => {this.props.checkItems(item, formNumber); this.onCheckChange()}} checked={checked}/></div>
        }
        {infoFields(item)}
        {editEnabled &&
        <div className='td form-buttons col-1'>
          <div className='td form-buttons col-1'>
            <div className='button edit'>
              <button className='edit-button' type='button' onClick={() => this.props.showEditForm(formNumber)}><EditOutlinedIcon/><span>&nbsp;Edit</span></button>
            </div>
          </div>
        </div>
        }
      </div>
    )
  }
}

function mapStateToProps ({table}) {
  return ({table})
}

export default connect(mapStateToProps, {checkItems, showEditForm, changeCheckAllBoxState})(ItemInfo)
